import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints.constant';

@Injectable({
  providedIn: 'root'
})
export class PlaylistService {

  constructor(private _apiService: ApiService) { }

  getAudioContentPlaylist(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}`
    return this._apiService.get(url, data)
  }
  getAudioContentPlaylistPublic(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}${API_ENDPOINTS.API.PUBLIC_CONTENTS}` + data
    return this._apiService.get(url)
  }
  getPlayList(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PLAYLIST}`
    return this._apiService.get(url, data)
  }

  createPlayList(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PLAYLIST}`
    return this._apiService.post(url, data)
  }

  showPlayList(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PLAYLIST}/${data}`
    return this._apiService.get(url)
  }

  deletePlaylist(data,type) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PLAYLIST}/${data}?library_type=${type}`
    return this._apiService.delete(url)
  }

  deletePlaylistContent(data, value) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.DELETE_PLAYLIST_CONTENT}/${value.id}`
    return this._apiService.delete(url, data)
  }

  publishPlaylist(data, value) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PUBLISH_PLAYLIST}/${value}`
    return this._apiService.put(url, data)
  }

  addAudioVideo(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}`
    return this._apiService.get(url, data)
  }

  addContentPlaylist(data, value) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.ADD_SONGS_VIDEOS}/${data}`
    return this._apiService.post(url, value)
  }

  shiftContentPlaylist(data, value) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.SHIFT_CONTENT_PLAYLIST}/${data}`
    return this._apiService.put(url, value)
  }

}
